<template>
  <!-- MODAL EDIT -->
  <b-modal
    id="modalEdit"
    title=""
    size="lg"
    @ok="handleOk"
  >
    <validation-observer ref="simpleRules">
      <b-row>
        <b-col
          md="12"
          lg="12"
        >
          <b-row>
            <b-col
              md="12"
              lg="6"
            >
              <!-- basic -->
              <b-form-group
                label="สายทาง"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    v-model="editData.wayid"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              md="12"
              lg="6"
            >
              <!-- basic -->
              <b-form-group
                label="ชื่อสายทาง"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    v-model="editData.wayname"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              md="12"
              lg="6"
            >
              <!-- basic -->
              <b-form-group
                label="ตำบล"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    v-model="editData.subdistrict"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col
              md="12"
              lg="6"
            >
              <!-- basic -->
              <b-form-group
                label="เขต"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Name"
                  rules="required"
                >
                  <b-form-input
                    v-model="editData.district"
                    type="text"
                    :state="errors.length > 0 ? false:null"
                    required
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- province -->
            <b-col
              lg="6"
              md="6"
            >
              <b-form-group
                label="จังหวัด"
                label-for="province"
              >
                <validation-provider
                  #default="{ errors }"
                  name="province"
                  rules="required"
                >
                  <v-select
                    v-model="editData.province"
                    :reduce="province => province.pname"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                    required
                    label="pname"
                    :options="province"
                    placeholder="เลือกจังหวัด..."
                    transition=""
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <!-- <b-col
              md="12"
              lg="6"
            >
              <b-form-group
                label="หน่วยงาน"
                label-for="department"
              >
                <validation-provider
                  #default="{ errors }"
                  name="department"
                  rules="required"
                >
                  <v-select
                    v-model="selectDepartment"
                    :reduce="department => department"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                    :state="errors.length > 0 ? false:null"
                    required
                    label="deptname"
                    :options="department"
                    placeholder="เลือกหน่วยงาน..."
                    transition=""
                    @input="editDepartment()"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col> -->

            <b-col
              md="12"
              lg="6"
            >
              <b-form-group
                label="ระยะทาง"
              >
                <b-form-input
                  v-model="editData.distance"
                  type="text"
                />
              </b-form-group>
            </b-col>
          </b-row>
        <!-- basic -->
        </b-col>
      </b-row>
    </validation-observer>
  </b-modal>
</template>

<script>
import axios from '@axios'
import {
  BRow, BCol, BFormInput, BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  data() {
    return {
      required,
      userData: JSON.parse(localStorage.getItem('userData')),
      department: [],
      province: [],
      selectDepartment: [],
      editData: {
        id: '',
        wayid: '',
        wayname: '',
        subdistrict: '',
        district: '',
        province: '',
        deptGroup: '',
        deptID: '',
        distance: '',
        department: '',
      },
    }
  },
  mounted() {
    this.dropdownWayDepartment()
    this.dropdownWayProvince()
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (!success) {
          // eslint-disable-next-line
          return
        }
        this.editWay()
        this.$nextTick(() => {
          this.$bvModal.hide('modalEdit')
        })
      })
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      // Trigger submit handler
      this.validationForm()
    },
    sendInfo(id) {
      this.id = id
      axios
        .post('/fetchWay', { id: this.id })
        .then(response => {
          console.log(response)
          this.editData.id = this.id
          this.editData.wayid = response.data.wayid
          this.editData.wayname = response.data.wayname
          this.editData.subdistrict = response.data.subdistrict
          this.editData.district = response.data.district
          this.editData.province = response.data.province
          this.editData.deptGroup = response.data.deptGroup
          this.editData.deptID = response.data.deptID
          this.editData.distance = response.data.distance
          this.editData.department = response.data.department
          this.dropdownWayDepartment()
          this.dropdownWayProvince()
        })
        .catch(error => {
          console.log(error)
        })
    },
    editWay() {
      const display = this.editData
      axios
        .post('/editWay', display)
        .then(response => {
          console.log(response)
          this.$swal({
            icon: 'success',
            title: '<span style="color:#000000">แก้ไขสำเร็จ</span>',
            showConfirmButton: false,
            timer: 1000,
          })
          this.$emit('fetch')
        })
        .catch(error => {
          console.log(error)
          this.$swal({
            icon: 'error',
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 2000,
          })
        })
    },
    editDepartment() {
      this.editData.deptID = this.selectDepartment.DeptID
      this.editData.deptGroup = this.selectDepartment.DeptGroup
    },
    dropdownWayDepartment() {
      axios
        .post('/dropdownDepartment')
        .then(response => {
          // console.log(response.data)
          this.department = response.data
        })
    },
    dropdownWayProvince() {
      axios
        .post('/dropdownProvince')
        .then(response => {
          // console.log(response.data)
          this.province = response.data
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/vue-select.scss';
</style>
